<template>
  <v-container fluid class="tradeindia-container pa-0 ma-0">
    <!-- Modern Header Section -->
    <div
      v-if="showHeader"
      class="header-section mb-6"
      style="margin: 0 12px; position: relative;"
    >
      <v-btn icon small class="header-close-btn" @click="dismissHeader">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <div class="d-flex align-center mb-4">
        <div class="header-icon-wrapper mr-4">
          <v-icon size="32" color="#FFFFFF">mdi-earth</v-icon>
        </div>
        <div>
          <h1 class="page-title mb-1">TradeIndia Integration</h1>
          <p class="page-subtitle mb-0">
            B2B marketplace integration for export-import leads
          </p>
        </div>
        <v-spacer></v-spacer>
        <div class="d-none d-sm-flex">
          <v-chip
            small
            class="mr-2"
            color="rgba(255,255,255,0.2)"
            text-color="white"
          >
            <v-icon small left>mdi-briefcase</v-icon>
            B2B Platform
          </v-chip>
        </div>
      </div>
      <v-row class="feature-pills ma-0">
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-email-open</v-icon>
            <span>Email Forward</span>
          </div>
        </v-col>
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-sync</v-icon>
            <span>Auto Sync</span>
          </div>
        </v-col>
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-account-tie</v-icon>
            <span>B2B Leads</span>
          </div>
        </v-col>
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white"
              >mdi-format-list-bulleted</v-icon
            >
            <span>List Mapping</span>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- Content Section -->
    <div style="padding: 0 12px;">
      <v-card class="customBorderRadius" elevation="2">
        <v-row class="ma-0">
          <v-col>
            <v-card
              color="transparent"
              elevation="0"
              style="padding: 10px; text-align: center !important"
            >
              <v-card-text style="margin-bottom: 25px">
                <!-- <h2 style="margin-bottom: 30px">
                      Lorem ipsum
                    </h2> -->
                <div
                  align="center"
                  style="margin-bottom: 10px; margin-top: 20%"
                >
                  <h1 style="margin-bottom: 40px">Godial + Trade India</h1>
                </div>
                <div style="padding: 5px 15px; text-align: center">
                  <!-- <h5
                        style="
                          line-height: 17px;
                          font-weight: 500;
                          font-size: 14px;
                        "
                      >
                        How to use?
                      </h5> -->

                  <div style="text-align: left">
                    <p
                      style="
                            margin-top: 20px;
                            font-size: 18px;
                            font-weight: 600;
                            margin-bottom: 10px;
                          "
                    >
                      How to use?
                    </p>
                    <p>
                      1. Enable Trade India
                      <br />
                      2. Select a list where you want to receive the leads, and
                      click save
                      <br />
                      3. Now you need to forward all trade india emails to the
                      Forwarding address
                      <br />
                      4. If you are using Gmail you will need to create a filter
                      and forward it, also your gmail verification email will
                      get forwarded to your manager account email
                      <br />
                      5. That is all you need to setup a trade india integration
                      via email
                    </p>
                  </div>
                  <!-- <p class="text-left">
                        For more details visit :
                        <a
                          target="_blank"
                          href="https://help.indiamart.com/knowledge-base/lms-crm-integration/"
                        >
                          this link</a
                        >
                      </p> -->
                </div>
              </v-card-text>
              <v-footer color="transparent" absolute>
                <v-flex style="text-align: center !important">
                  <p
                    style="
                          font-size: 12px;
                          opacity: 0.9;
                          margin-bottom: 0px;
                        "
                  >
                    Feel free to reach out to us at
                    <a href="mailto:support@godial.cc">support@godial.cc</a>
                    if you are interested in these features
                  </p>
                </v-flex>
              </v-footer>
            </v-card>
          </v-col>
          <v-col>
            <v-card flat>
              <v-flex xs12 sm10 offset-sm1 md10 offset-md1>
                <v-layout row wrap>
                  <v-flex
                    d-flex
                    justify-center
                    class="mt-10"
                    style="padding-top: 22px"
                    >Enable Trade India
                  </v-flex>
                  <v-flex class="mt-10" d-flex justify-center>
                    <v-switch
                      v-model="tradeIndia.enabled"
                      color="primary"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card>
            <v-card
              color="transparent"
              elevation="0"
              style="margin-top:25px; padding: 15px 50px; text-align: center"
            >
              <v-card-title primary-title class="justify-center"
                >TradeIndia Credentials</v-card-title
              >

              <!-- <v-flex xs12 sm12 offset-sm1 md12 offset-md1>
              <v-text-field
                v-model="tradeIndia.config.email"
                readonly
                label="Forwarding Email"
                type="text"
                rows="3"
                prepend-inner-icon="email"
              ></v-text-field>
            </v-flex> -->

              <!--? User ID -->
              <v-flex xs12 sm12 offset-sm1 md12 offset-md1>
                <v-text-field
                  v-model="tradeIndia.config.userId"
                  label="User Id"
                  type="text"
                  rows="3"
                  :disabled="!tradeIndia.enabled"
                  prepend-inner-icon="verified_user"
                ></v-text-field>
              </v-flex>

              <!--? Profile Id -->
              <v-flex xs12 sm12 offset-sm1 md12 offset-md1>
                <v-text-field
                  v-model="tradeIndia.config.profileId"
                  label="Profile Id"
                  type="text"
                  rows="3"
                  :disabled="!tradeIndia.enabled"
                  prepend-inner-icon="account_circle"
                ></v-text-field>
              </v-flex>

              <!--? Key -->
              <v-flex xs12 sm12 offset-sm1 md12 offset-md1>
                <v-text-field
                  v-model="tradeIndia.config.inquiry_key"
                  label=" Inquiry Key"
                  type="text"
                  rows="3"
                  :disabled="!tradeIndia.enabled"
                  prepend-inner-icon="vpn_key"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 offset-sm1 md12 offset-md1>
                <v-autocomplete
                  v-model="tradeIndia.config.inquiry_listId"
                  :disabled="!tradeIndia.enabled"
                  class="pt-1"
                  :items="lists"
                  item-text="name"
                  item-value="id"
                  label="Inquiry Lists"
                  prepend-inner-icon="view_list"
                  autocomplete="false"
                  outlined
                  dense
                />
              </v-flex>

              <v-flex xs12 sm12 offset-sm1 md12 offset-md1>
                <v-text-field
                  v-model="tradeIndia.config.buyleads_key"
                  label=" Buy leads Key"
                  type="text"
                  rows="3"
                  :disabled="!tradeIndia.enabled"
                  prepend-inner-icon="vpn_key"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 offset-sm1 md12 offset-md1>
                <v-autocomplete
                  v-model="tradeIndia.config.buyleads_listId"
                  :disabled="!tradeIndia.enabled"
                  class="pt-1"
                  :items="lists"
                  item-text="name"
                  item-value="id"
                  label="Buy leads Lists"
                  prepend-inner-icon="view_list"
                  autocomplete="false"
                  outlined
                  dense
                />
              </v-flex>

              <v-card-text>
                <v-flex
                  xs12
                  sm10
                  offset-sm1
                  md10
                  offset-md1
                  style="margin-bottom: 10px"
                >
                  <v-btn color="primarygrad" dark block @click="setTradeIndia"
                    >Save</v-btn
                  >
                </v-flex>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

      <!-- Loader -->
      <v-dialog v-model="loader" persistent width="300">
        <v-card color="primary white--text" dark>
          <v-card-text style="padding: 18px 25px">
            <h3 style="margin-bottom: 5px; font-weight: 400; font-size: 16px">
              Please Wait...
            </h3>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import fb from "../../js/firebase";

export default {
  data() {
    return {
      showHeader: false,
      tradeIndia: {
        type: "tradeIndia",
        config: {
          // email: "",
          userId: "",
          profileId: "",
          inquiry_key: "",
          inquiry_listId: "",
          buyleads_key: "",
          buyleads_listId: "",
        },
        listId: "",
        companyId: "",
        enabled: false,
      },
      loader: false,
      lists: [],
    };
  },

  computed: {
    ...mapGetters(["ENDPOINT", "companyDetails", "selectedTeam"]),
  },
  watch: {},
  created() {
    this.showHeader =
      localStorage.getItem("tradeIndiaHeaderDismissed") !== "true";
    this.fetchLists();
    this.getTradeIndiaDetails();
    this.tradeIndia.companyId = this.companyDetails.id;

    console.log(this.companyDetails.id);
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("tradeIndiaHeaderDismissed", "true");
    },
    async getTradeIndiaDetails() {
      var resp = await this.$http.get(
        `${this.ENDPOINT}/integrations?filter[where][companyId]=${this.companyDetails.id}&filter[where][type]=tradeindia`,
      );

      console.log("trade india data", resp.body);

      if (resp.body.length > 0) this.tradeIndia = resp.body[0];
    },
    getTeamIds() {
      var teams = [];
      if (this.selectedTeam == "allTeams") {
        teams = _.map(this.teams, "id");
      } else {
        teams.push(this.selectedTeam);
      }

      teams = _.without(teams, "allTeams");

      return teams;
    },
    async fetchLists() {
      try {
        this.lists = [];
        var response = [];

        var teamIds = this.getTeamIds();

        // Teams sections
        response = await this.$http.post(`${this.ENDPOINT}/lists/fetch`, {
          teams: teamIds,
        });
        this.lists = response.body;

        if (this.lists.length < 1) {
          this.loader = false;
          return;
        }
      } catch (e) {
        this.loader = false;
        console.log("error in list fetch", e);
      }
    },

    async setTradeIndia() {
      this.loader = true;
      try {
        this.tradeIndia.companyId = this.companyDetails.id;
        this.tradeIndia.type = "tradeindia";
        this.tradeIndia.config.email = `ti-${this.companyDetails.id}@mg.godial.cc`;
        var res = {};
        //If new user
        if (typeof this.tradeIndia.id == "undefined") {
          // Add Indiamart Details In Company Data
          res = await this.$http.post(
            `${this.ENDPOINT}/integrations`,
            this.tradeIndia,
          );
        } else {
          var data = JSON.parse(JSON.stringify(this.tradeIndia));
          delete data.id;
          res = await this.$http.put(
            `${this.ENDPOINT}/integrations/${this.tradeIndia.id}`,
            data,
          );
        }
        // Success Message
        if (res.status == 200) {
          // Set Company Object for Store dispatch
          this.getTradeIndiaDetails();
          this.loader = false;
          try {
            fb.log("tradeIndia_added");
          } catch (e) {
            console.log("Error in FB log", e);
          }
          return this.$swal({
            type: "success",
            text: "TradeIndia Added to Godial Successfully",
          });
        } else {
          return this.$swal({
            type: "warning",
            text: "Something Went Wrong",
          });
        }
      } catch (err) {
        console.log(err);
        this.loader = false;
        return this.$swal({
          type: "warning",
          text: err.body.error.message,
        });
      }
    },
  },
};
</script>

<style scoped>
.tradeindia-container {
  background-color: var(--v-background-base, #f5f5f5);
  min-height: 100vh;
}

.theme--dark .tradeindia-container {
  background-color: #121212 !important;
}
</style>

<style></style>
